import { useCallback } from 'react';
import { hooks } from '@febos-io/common';
import { getSettings } from '../config';

export const useGetUserSettingsCallback = () => {
  const { callback, loading, } = hooks.useRequestCallback(
    useCallback(async (request) => {
      const response = await request.exec(getSettings());
      return response;
    }, [])
  );

  return {
    loading,
    callback,
  };
};

export default useGetUserSettingsCallback;
